/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
import { AxiosResponse } from 'axios'
import hosts from 'config/microServices'
import { IChegada } from 'Models/docas'
import IAtualizacaoPlaca from 'Models/docas/IAtualizacaoPlaca'
import IFormListaChegadaFilter from 'Models/docas/IFormListaChegadaFilter'
import ApiService from 'Services/ApiService'
import AtualizaPlacaResponse from 'Types/AtualizaPlacaResponse'
import {
  ServiceListResponse,
  ServiceUpdateResponse,
} from 'Types/ServiceResponse'

const listaChegadas = {
  get: async (idComponente: number, cdChegada: number) => {
    const result: AxiosResponse<ServiceListResponse<IChegada>> =
      await ApiService({ idComponente }).get<ServiceListResponse<IChegada>>(
        `${hosts.WS_DOCAS}/chegada/${cdChegada}`,
      )

    return result
  },

  buscaChegadas: async (
    idComponente: number,
    filter: IFormListaChegadaFilter,
  ) => {
    const body = {
      visualizado: filter.visualizado,
      dataInicial: filter.dataInicial,
      dataFinal: filter.dataFinal,
      placas: filter.placas,
      tipoOperacao: filter.tipoOperacao,
      armazens: filter.armazens,
    }

    const result: AxiosResponse<ServiceListResponse<IChegada>> =
      await ApiService({
        idComponente,
      }).post<ServiceListResponse<IChegada>>(
        `${hosts.WS_DOCAS}/busca_lista_chegadas`,
        body,
      )

    return result
  },

  visualizaChegada: async (
    idComponente: number,
    cdIntegracaoCameraPlaca: number,
  ) => {
    const result: AxiosResponse<ServiceUpdateResponse> = await ApiService({
      idComponente,
    }).put<ServiceUpdateResponse>(
      `${hosts.WS_DOCAS}/visualiza_chegada/${cdIntegracaoCameraPlaca}`,
      undefined,
    )

    return result
  },

  descartaChegada: async (
    idComponente: number,
    cdIntegracaoCameraPlaca: number,
  ) => {
    const result: AxiosResponse<ServiceUpdateResponse> = await ApiService({
      idComponente,
    }).delete<ServiceUpdateResponse>(
      `${hosts.WS_DOCAS}/descarta_chegada/${cdIntegracaoCameraPlaca}`,
      undefined,
    )

    return result
  },

  buscaImagens: async (
    idComponente: number,
    cdIntegracaoCameraPlaca: number,
  ) => {
    const result: AxiosResponse<ServiceListResponse<string>> = await ApiService(
      {
        idComponente,
      },
    ).get<ServiceListResponse<string>>(
      `${hosts.WS_DOCAS}/busca_imagens/${cdIntegracaoCameraPlaca}`,
    )

    return result
  },

  atualizaPlaca: async (idComponente: number, dados: IAtualizacaoPlaca) => {
    const result: AxiosResponse<AtualizaPlacaResponse> = await ApiService({
      idComponente,
    }).put<ServiceUpdateResponse>(`${hosts.WS_DOCAS}/atualiza_placa`, dados)

    return result
  },

  contaChegadasNaoCadastradas: async (idComponente: number) => {
    const result: AxiosResponse<ServiceListResponse<number>> = await ApiService(
      {
        idComponente,
      },
    ).get<ServiceListResponse<number>>(
      `${hosts.WS_DOCAS}/conta_chegadas_nao_cadastradas`,
    )

    return result
  },
}

export default listaChegadas
